<template>
  <v-col
    cols="12"
    style="min-height: 66px"
  >
    <slot name="breadcrumbs">
      <v-breadcrumbs
        :items="breadcrumbItems"
        class="pa-0 d-inline-block"
      >
        <template #item="{item}">
          <v-breadcrumbs-item
            :active-class="(item.disabled && item.tooltip ? 'v-breadcrumbs__item--disabled v-breadcrumbs__item--tooltip' : 'v-breadcrumbs__item--disabled')"
            :disabled="item.disabled"
            :exact="item.exact"
            :to="item.to"
          >
            {{ item.text }}
            <infotip
              v-if="item.tooltip"
              icon-style="margin-top: -16px"
              position="bottom"
            >
              {{ item.tooltip }}
            </infotip>
          </v-breadcrumbs-item>
        </template>
        <template #divider>
          <v-icon size="20">
            mdi-menu-right
          </v-icon>
        </template>
      </v-breadcrumbs>
    </slot>

    <div
      v-if="secondaryButton"
      class="d-inline-block float-right"
    >
      <slot name="secondaryButton">
        <v-btn
          :color="secondaryButtonColor"
          :disabled="secondaryButtonDisabled"
          v-bind="secondaryButtonTo ? {to: {name: primaryButtonTo, secondaryQuery}} : {}"
          class="synthesis-text text-size-14 white--text"
          depressed
          height="42"
          large
          @click="$emit('click-secondary-button')"
        >
          <v-icon
            v-if="secondaryButtonIcon"
            left
          >
            {{ secondaryButtonIcon }}
          </v-icon>
          {{ secondaryButtonTitle }}
        </v-btn>
      </slot>
    </div>

    <div
      v-if="primaryButton && !isDraftStatus"
      class="d-inline-block float-right mr-3"
    >
      <slot name="primaryButton">
        <v-btn
          :color="primaryButtonColor"
          :disabled="primaryButtonDisabled"
          v-bind="primaryButtonTo ? {to: {name: primaryButtonTo, query}} : {}"
          class="synthesis-text text-size-14 white--text"
          depressed
          height="42"
          large
          @click="$emit('click-primary-button')"
        >
          <v-icon
            v-if="primaryButtonIcon"
            left
          >
            {{ primaryButtonIcon }}
          </v-icon>
          {{ primaryButtonTitle }}
        </v-btn>
      </slot>
    </div>

    <!-- Draft Status Buttons -->
    <div
      v-if="isDraftStatus"
      class="d-inline-block float-right draft-buttons"
    >
      <v-btn
        class="cancel-btn synthesis-text text-size-14"
        depressed
        height="42"
        large
        @click="$emit('click-cancel')"
      >
        {{ $t('Common.Button.Cancel') }}
      </v-btn>
    </div>
  </v-col>
</template>

<script>
import Infotip from '@/theme/default/components/common/Infotip'

export default {
  name      : 'SectionHeader',
  components: { Infotip },
  directives: {},
  mixins    : [],
  props     : {
    breadcrumbItems: {
      type    : Array,
      required: true
    },
    primaryButton: {
      type   : Boolean,
      default: false
    },
    primaryButtonTitle: {
      type   : String,
      default: ''
    },
    primaryButtonIcon: {
      type   : String,
      default: 'mdi-plus-circle-outline'
    },
    primaryButtonColor: {
      type   : String,
      default: 'synthesis-ui-green-01'
    },
    primaryButtonTo: {
      type   : String,
      default: ''
    },
    primaryButtonDisabled: {
      type   : Boolean,
      default: false
    },
    query: {
      type   : Object,
      default: () => ({})
    },
    secondaryButton: {
      type   : Boolean,
      default: false
    },
    secondaryButtonTitle: {
      type   : String,
      default: ''
    },
    secondaryButtonIcon: {
      type   : String,
      default: 'mdi-plus-circle-outline'
    },
    secondaryButtonColor: {
      type   : String,
      default: 'synthesis-ui-green-01'
    },
    secondaryButtonTo: {
      type   : String,
      default: ''
    },
    secondaryButtonDisabled: {
      type   : Boolean,
      default: false
    },
    secondaryQuery: {
      type   : Object,
      default: () => ({})
    },
    isDraftStatus: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {
    currentAnalysisId : 'ActiveAnalysis.currentAnalysisId',
    previousAnalysisId: 'ActiveAnalysis.previousAnalysisId'
  },
  enums    : {},
  dataModel: null,
  data () {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods : {}
}
</script>

<style scoped>
/* Breadcrumbs Override */
::v-deep .v-breadcrumbs li {
  color: var(--v-synthesis-ui-grey-01-base);
  font-weight: 500;
  font-size: 24px;
}

::v-deep .v-breadcrumbs li a, ::v-deep .v-breadcrumbs__item--disabled li a {
  color: var(--v-synthesis-ui-grey-01-base) !important;
}

::v-deep .v-breadcrumbs__item--disabled {
  color: var(--v-synthesis-brand-dark-blue-base) !important;
}

::v-deep .v-breadcrumbs__item--tooltip {
  pointer-events: auto;
  cursor: default;
}

::v-deep .v-breadcrumbs li:nth-child(even) {
  padding: 0 8px;
}

/* Draft Status Buttons Styling */
.draft-buttons {
  display: flex;
}

.draft-buttons .cancel-btn {
  margin-right: 12px;
}

.cancel-btn {
  background-color: var(--v-synthesis-ui-grey-04-base) !important;
  color: var(--v-synthesis-brand-dark-blue-base) !important;
}

.mr-3 {
  margin-right: 3px;
}

</style>
